(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/svs-fetch/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/core/svs-fetch/assets/javascripts/helpers.js');

'use strict';

svs.core.svsFetch = svs.core.svsFetch || {};
svs.core.svsFetch.helpers = svs.core.svsFetch.helpers || {};
const helpers = svs.core.svsFetch.helpers;

helpers.METHODS_REQUIRING_CONTENT_TYPE = ['POST', 'PUT', 'PATCH'];

helpers.validateContentType = function (method, headers) {
  if (helpers.METHODS_REQUIRING_CONTENT_TYPE.includes(method) && !headers.get('content-type')) {
    throw new Error('Request is missing Content-Type Header');
  }
};

helpers.validateBaseUrl = function (baseUrl) {
  if (!baseUrl) {
    return;
  }
  try {
    const parsed = new URL(baseUrl);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      throw new Error("Invalid baseUrl protocol: ".concat(parsed.protocol, ". Must be http: or https:"));
    }
  } catch (err) {
    if (err.message.includes('Invalid baseUrl')) {
      throw err;
    }
    throw new Error("Invalid baseUrl '".concat(baseUrl, "': ").concat(err.message));
  }
};

helpers.resolveUrl = function (base, urlPath) {
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const normalizedPath = urlPath.startsWith('/') ? urlPath : "/".concat(urlPath);
  const resolvedUrl = normalizedBase + normalizedPath;
  return {
    resolvedUrl,
    parsedUrl: new URL(resolvedUrl)
  };
};

 })(window);